export default "__VITE_ASSET__p7t8upnw__"